import React from 'react';

function DataDeletion() {
  return (
    <div style={{
      fontFamily: '"Nunito Sans", sans-serif',
      lineHeight: 1.6,
      color: '#333',
      backgroundColor: '#fff',
      WebkitFontSmoothing: 'antialiased',
      MozOsxFontSmoothing: 'grayscale'
    }}>
      <div style={{
        maxWidth: 1200,
        margin: '0 auto',
        padding: '50px 20px'
      }}>
        <div style={{
          margin: '50px 100px',
          marginBottom: 50
        }}>
          <h1 style={{
            textAlign: 'center',
            marginBottom: 30,
            fontSize: '2.5rem',
            fontWeight: 700,
            color: '#2c3e50'
          }}>User Data Deletion</h1>

          <h2 style={{
            fontSize: '1.5rem',
            fontWeight: 600,
            marginTop: 30,
            marginBottom: 15,
            color: '#34495e'
          }}>刪除用戶數據</h2>

          <p style={{ marginBottom: 15, textAlign: 'justify' }}>
            If you would like to delete your user data from Vivablee, please note that requesting data deletion will also result in the deletion of your app account.
          </p>

          <p style={{ marginBottom: 15, textAlign: 'justify' }}>
            如果您想刪除您在 Vivablee 的用戶數據，請注意，請求刪除數據將同時導致您的應用程式帳戶被刪除。
          </p>

          <div style={{
            backgroundColor: '#fff3cd',
            padding: 20,
            borderRadius: 8,
            margin: '30px 0',
            borderLeft: '4px solid #ffc107'
          }}>
            <h3 style={{
              fontSize: '1.2rem',
              fontWeight: 600,
              marginBottom: 15,
              color: '#2c3e50'
            }}>How to Request Data Deletion 如何請求刪除數據</h3>

            <p style={{ marginBottom: 15, textAlign: 'justify' }}>
              To request the deletion of your data and account, please send an email to:
            </p>

            <p style={{ marginBottom: 15, textAlign: 'justify' }}>
              要請求刪除您的數據和帳戶，請發送電子郵件至：
            </p>

            <p style={{
              marginBottom: 15,
              fontSize: '1.2rem',
              fontWeight: 600,
              textAlign: 'center',
              color: '#007bff'
            }}>
              <a href="mailto:info@vivablee.com" style={{
                color: '#007bff',
                textDecoration: 'none'
              }}>
                info@vivablee.com
              </a>
            </p>
          </div>

          <div style={{
            backgroundColor: '#f8f9fa',
            padding: 20,
            borderRadius: 8,
            margin: '30px 0',
            borderLeft: '4px solid #dc3545'
          }}>
            <h3 style={{
              fontSize: '1.2rem',
              fontWeight: 600,
              marginBottom: 15,
              color: '#dc3545'
            }}>Important Notice 重要提示</h3>

            <p style={{ marginBottom: 15, textAlign: 'justify' }}>
              <strong>Please be aware:</strong>
            </p>

            <ul style={{ marginLeft: 40, marginBottom: 15 }}>
              <li style={{ marginBottom: 8 }}>
                Requesting data deletion will permanently delete your account and all associated data.
              </li>
              <li style={{ marginBottom: 8 }}>
                This action cannot be undone.
              </li>
              <li style={{ marginBottom: 8 }}>
                You will no longer be able to access your account or any content associated with it.
              </li>
              <li style={{ marginBottom: 8 }}>
                We will process your request in accordance with our Privacy Policy and applicable data protection laws.
              </li>
            </ul>

            <p style={{ marginBottom: 15, textAlign: 'justify' }}>
              <strong>請注意：</strong>
            </p>

            <ul style={{ marginLeft: 40, marginBottom: 15 }}>
              <li style={{ marginBottom: 8 }}>
                請求刪除數據將永久刪除您的帳戶和所有相關數據。
              </li>
              <li style={{ marginBottom: 8 }}>
                此操作無法撤銷。
              </li>
              <li style={{ marginBottom: 8 }}>
                您將無法再訪問您的帳戶或與之相關的任何內容。
              </li>
              <li style={{ marginBottom: 8 }}>
                我們將根據我們的私隱政策和適用的數據保護法律處理您的請求。
              </li>
            </ul>
          </div>

          <div style={{
            backgroundColor: '#e7f3ff',
            padding: 20,
            borderRadius: 8,
            margin: '30px 0',
            borderLeft: '4px solid #007bff'
          }}>
            <h3 style={{
              fontSize: '1.2rem',
              fontWeight: 600,
              marginBottom: 15,
              color: '#2c3e50'
            }}>What to Include in Your Request 請求中應包含的內容</h3>

            <p style={{ marginBottom: 15, textAlign: 'justify' }}>
              When sending your data deletion request, please include:
            </p>

            <ul style={{ marginLeft: 40, marginBottom: 15 }}>
              <li style={{ marginBottom: 8 }}>
                Your registered email address
              </li>
              <li style={{ marginBottom: 8 }}>
                Subject line: "Data Deletion Request"
              </li>
              <li style={{ marginBottom: 8 }}>
                Confirmation that you understand your account will be permanently deleted
              </li>
            </ul>

            <p style={{ marginBottom: 15, textAlign: 'justify' }}>
              發送數據刪除請求時，請包含：
            </p>

            <ul style={{ marginLeft: 40, marginBottom: 15 }}>
              <li style={{ marginBottom: 8 }}>
                您註冊的電子郵件地址
              </li>
              <li style={{ marginBottom: 8 }}>
                主題：「數據刪除請求」
              </li>
              <li style={{ marginBottom: 8 }}>
                確認您了解您的帳戶將被永久刪除
              </li>
            </ul>
          </div>

          <p style={{ marginBottom: 15, textAlign: 'justify', marginTop: 30 }}>
            We will process your request within 40 days and send you a confirmation email once the deletion is complete.
          </p>

          <p style={{ marginBottom: 15, textAlign: 'justify' }}>
            我們將在 40 天內處理您的請求，並在刪除完成後向您發送確認電子郵件。
          </p>

          <div style={{ marginTop: 40, textAlign: 'center' }}>
            <p style={{ marginBottom: 15 }}>
              For more information, please refer to our{' '}
              <a href="/PrivacyPolicy" style={{ color: '#007bff', textDecoration: 'none' }}>
                Privacy Policy
              </a>
            </p>
            <p style={{ marginBottom: 15 }}>
              如需更多信息，請參閱我們的{' '}
              <a href="/PrivacyPolicy" style={{ color: '#007bff', textDecoration: 'none' }}>
                私隱政策
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DataDeletion;
